/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import Avatar from 'avataaars';
import seedrandom from 'seedrandom';
import { jsx } from 'theme-ui';
export default function ContactAvatar({ seed, ...rest }) {
  const appearance = useRandomAppearance(seed?.toLowerCase()); // Same avatar for different capitalization.
  return <Avatar avatarStyle="Circle" {...appearance} {...rest} />;
}

function useRandomAppearance(seed) {
  const rng = seedrandom(seed);
  const appearance = {
    topType: select('topType', rng()),
    accessoriesType: select('accessoriesType', rng()),
    hairColor: select('hairColor', rng()),
    facialHairType: select('facialHairType', rng()),
    facialHairColor: select('facialHairColor', rng()),
    clotheType: select('clotheType', rng()),
    clotheColor: select('clotheColor', rng()),
    eyeType: select('eyeType', rng()),
    eyebrowType: select('eyebrowType', rng()),
    mouthType: select('mouthType', rng()),
    skinColor: select('skinColor', rng()),
  };

  return appearance;
}

function select(type, pseudoRandom) {
  return options[type]?.[Math.floor(pseudoRandom * options[type]?.length)];
}

const options = {
  topType: [
    'NoHair',
    'Eyepatch',
    'Hat',
    'Hijab',
    'Turban',
    // 'WinterHat1',
    // 'WinterHat2',
    'WinterHat3',
    'WinterHat4',
    'LongHairBigHair',
    'LongHairBob',
    'LongHairBun',
    'LongHairCurly',
    'LongHairCurvy',
    'LongHairDreads',
    'LongHairFrida',
    'LongHairFro',
    'LongHairFroBand',
    'LongHairNotTooLong',
    'LongHairShavedSides',
    'LongHairMiaWallace',
    'LongHairStraight',
    'LongHairStraight2',
    'LongHairStraightStrand',
    'ShortHairDreads01',
    'ShortHairDreads02',
    'ShortHairFrizzle',
    'ShortHairShaggyMullet',
    'ShortHairShortCurly',
    'ShortHairShortFlat',
    'ShortHairShortRound',
    'ShortHairShortWaved',
    'ShortHairSides',
    'ShortHairTheCaesar',
    'ShortHairTheCaesarSidePart',
  ],
  accessoriesType: [
    'Blank',
    'Kurt',
    'Prescription01',
    'Prescription02',
    'Round',
    'Sunglasses',
    'Wayfarers',
  ],

  hairColor: [
    'Auburn',
    'Black',
    'Blonde',
    'BlondeGolden',
    'Brown',
    'BrownDark',
    'PastelPink',
    'Platinum',
    'Red',
    'SilverGray',
  ],
  facialHairType: [
    'Blank',
    'Blank', // Make facial hair less probable.
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'Blank',
    'BeardMedium',
    'BeardLight',
    'BeardMagestic',
    'MoustacheFancy',
    'MoustacheMagnum',
  ],
  facialHairColor: [
    'Auburn',
    'Black',
    'Blonde',
    'BlondeGolden',
    'Brown',
    'BrownDark',
    'Platinum',
    'Red',
  ],
  clotheType: [
    'BlazerShirt',
    'BlazerSweater',
    'CollarSweater',
    'GraphicShirt',
    'Hoodie',
    'Overall',
    'ShirtCrewNeck',
    'ShirtScoopNeck',
    'ShirtVNeck',
  ],
  clotheColor: [
    'Black',
    // 'Blue01', // Same as background.
    'Blue02',
    'Blue03',
    'Gray01',
    'Gray02',
    'Heather',
    'PastelBlue',
    'PastelGreen',
    'PastelOrange',
    'PastelRed',
    'PastelYellow',
    'Pink',
    'Red',
    'White',
  ],
  eyeType: [
    'Close',
    // 'Cry',
    'Default',
    // 'Dizzy',
    // 'EyeRoll',
    'Happy',
    // 'Hearts',
    'Side',
    'Squint',
    'Surprised',
    // 'Wink',
    // 'WinkWacky',
  ],
  eyebrowType: [
    // 'Angry',
    // 'AngryNatural',
    'Default',
    'DefaultNatural',
    'FlatNatural',
    'RaisedExcited',
    'RaisedExcitedNatural',
    'SadConcerned',
    'SadConcernedNatural',
    'UnibrowNatural',
    'UpDown',
    'UpDownNatural',
  ],
  mouthType: [
    // 'Concerned',
    'Default',
    // 'Disbelief',
    // 'Eating',
    // 'Grimace',
    // 'Sad',
    // 'ScreamOpen',
    // 'Serious',
    'Smile',
    // 'Tongue',
    'Twinkle',
    // 'Vomit',
  ],
  skinColor: [
    'Tanned',
    'Yellow',
    'Pale',
    'Light',
    'Brown',
    'DarkBrown',
    'Black',
  ],
};
